import React, { useCallback, useRef } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "../OtpInput";
import { toast } from "react-toastify";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import rightTick from "../../../asset/images/rightTick-Circle.svg";
import {
  AESEncryption,
  ApiResDecrypt,
  maskEmail,
} from "../../../CommonMethhods/CommonMethods";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import SmallLoader from "../../../Components/Common/smallLoader";
import { useClientContext } from "../../../context/ClientContext";
import { useResumeContext } from "../../../CommonMethhods/Context";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function IndividualEmailCard(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const noVerified = localStorage.getItem("IndiMobileNo");
  const [otpModal, setOtpModal] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [isOtpComplete, setIsOtpComplete] = useState(false);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [otpVerified, setOtpVerified] = useState(false);
  const [checkRelation, setCheckRelation] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const relation = props?.relation;
  const inputRef = useRef(null);
  const [initialEmail, setInitialEmail] = useState("");
  const activeTab= props.activeTab;
  const resumeVal = props?.resumeVal?.verificationDetails;
  const { selectedClient, shouldPrefill } = useClientContext();
  const { resumeHandle } = useResumeContext();

  console.log(resumeVal, noVerified, "resumeValEmail");

  const errorSchema = Yup.object().shape({
    emailValid: Yup.string()
      .required("Email ID is required")
      // .matches(
      //   /^(?!.*\.\.)[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
      //   "Enter Valid Email ID"
      // ),
      .matches(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        "Please enter a valid email ID"
      )
      .test('no-special-char-start', 'The local part of the email cannot start with a special character.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > 0) {
          const localPart = value.substring(0, atPos);
          if (/^[.!#$%&'*+/=?^_`{|}~-]/.test(localPart[0])) {
            return false;
          }
        }
        return true;
      })
      .test('dot-before-at', 'A dot (.) or special character cannot be immediately before the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > 0) {
          const charBeforeAt = value[atPos - 1];
          return /^[a-zA-Z0-9]$/.test(charBeforeAt);
        }
        return true;
      })
      .test('no-digit-after-at', 'The domain part cannot contain digits after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1);  // The part after '@'
          // Ensure that no digits exist in the domain part
          if (/\d/.test(domainPart)) {  // Check if there are digits anywhere after '@'
            return false;
          }
        }
        return true;
      })
      .test('no-special-char-after-at', 'The domain part cannot contain special characters after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1);  // The part after '@'
          // Ensure no special characters except for '.' in the domain part
          if (/[^a-zA-Z0-9.]/.test(domainPart)) {
            return false;
          }
        }
        return true;
      })
      .test('dot-required-after-at', 'The domain part must contain at least one dot (.) after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1); // The part after '@'
          if (!domainPart.includes('.')) {  // Check if the domain part contains a dot (.)
            return false;
          }
        }
        return true;
      }),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    reset: resetForm,
    setError,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const watchedEmail = useWatch({control, name: "emailValid" });
  const initialVal = activeTab !== "individual";
  const effectiveEmail = initialVal ? "" : watchedEmail;

  useEffect(()=> {
    if(initialVal){
      clearErrors()
      setValue("emailValid", "");
      setCheckRelation("")
      setInitialEmail("")
    } else if(shouldPrefill && selectedClient?.mobile && resumeVal?.email){
      // setCheckRelation(resumeVal?.relation)
      setInitialEmail(resumeVal?.email);
      setValue("emailValid", resumeVal?.email);
    }
  }, [activeTab, shouldPrefill, selectedClient, resumeVal, initialVal]);

  const sendEmailOtp = async (data, resend) => {
    if(resend !== "true"){
      setOtpLoader(true);
    }

    let payloadValue = { emailId: resumeVal?.email ? resumeVal?.email : data };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValueEmail");
    try {
      const getOtp = await axiosInstance.post(
        Lead_Creation.Send_Mail_OTP,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getOtp?.data);
      if (res?.status === 0) {
        resumeHandle()
        setOtpModal(true);
        setMinutes(0);
        setSeconds(30);
        setOtpValues(Array(4)?.fill(""));
      } else {
        setOtpModal(false);
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOtpLoader(false);
    }
  };

  const getLeadCreation = async (email) => {
    let payloadValue = {
      mobile: "",
      email: email,
      source: "Comos-HNI",
      utmSource: "Individual",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getOtp = await axiosInstance.post(
        Lead_Creation.Leade_Create,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getOtp?.data);

      if (res?.status === 0) {
        console.log(res, "resLead");
      } else {
        console.log(res?.message, "errResp");

        // toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } 
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const validateEmailOtp = async () => {
    const otpString = otpValues?.join("");
    let payloadValue = {
      email: getValues("emailValid"),
      otp: otpString,
      mobileNo: noVerified || resumeVal?.mobileNo,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const verifyOtp = await axiosInstance.post(
        Lead_Creation.Validate_Mail_OTP,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(verifyOtp?.data);
      if (res?.status === 0) {
        if (res?.data?.isEmailIdRegistered === "YES") {
          setError("emailValid", {
            type: "manual",
            message:
              "Email id is already registered with us. Please select relation to proceed.",
          });
          localStorage.setItem("mailAlreadyRegis",res?.data?.isEmailIdRegistered);

        } else {
          props.setEmailVerify(true)
          localStorage.setItem("mailAlreadyRegis",res?.data?.isEmailIdRegistered);
        }
        localStorage.setItem("IndiEmail", getValues("emailValid"));
        setOtpVerified(true);
        setOtpModal(false);
        setValue("emailValid", getValues("emailValid"), {
          shouldValidate: true,
        });
        toast.success(res?.data?.msg);
      } else {
        toast.error(res?.message);
        setOtpValues(Array(4)?.fill(""));
        setTimeout(() => {
          document.getElementById("otp-input-0")?.focus();
        }, 100);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onHide = () => {
    setOtpModal(false);
  };

  function otpBtn() {
    sendEmailOtp(getValues("emailValid"), "true");
  }

  const handleVerifyData = () => {
    if (otpValues?.length === 4) {
      validateEmailOtp();
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const mailVerified = localStorage.getItem("IndiEmail");
  const mailAlreadyRegis = localStorage.getItem("mailAlreadyRegis");
  const saveRelationEmailVal = localStorage.getItem("SaveRelationEmail");

  const saveRelation = async () => {
    setSaveLoader(true);
    let payloadValue = {
      mobileNo: "",
      emailId: getValues("emailValid"),
      relation: checkRelation,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.Save_Relation,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        clearErrors("emailValid");
        toast.success(res?.data);
        localStorage.setItem("SaveRelationEmail", true);
        props.setEmailVerify(true)
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSaveLoader(false);
    }
  };

  const onFinalSubmit = (data) => {
    if (data?.emailValid?.length > 0 && mailAlreadyRegis === null) {
      getLeadCreation(data?.emailValid);
      sendEmailOtp(data?.emailValid);
    } else {
      saveRelation();
    }
  };

  useEffect(() => {
    if (mailVerified?.length > 0) {
      setError("emailValid", {
        type: "manual",
        message:
          "Email id is already registered with us. Please select relation to proceed.",
      });
    }else{
      clearErrors()
    }
  }, [mailVerified]);

  const handlePaste = (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/[^a-zA-Z0-9@.]/g, "");
    const atIndex = clean.indexOf("@");
    if (atIndex !== -1) {
      const beforeAt = clean.slice(0, atIndex + 1);
      const afterAt = clean.slice(atIndex + 1).replace(/@/g, "");
      clean = beforeAt + afterAt;
    }
    clean = clean.replace(/\.{2,}/g, ".");
    clean = clean.replace(/\.@/g, "@");
    clean = clean.replace(/^[@.]+|[@.]+$/g, "");
  
    setValue("emailValid", clean, { shouldValidate: true });
  };

  const handleEmailInput =  (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9@.]/g, "");

    if (/^[@.]/.test(value)) {
      value = value.substring(1);
    }
    const atParts = value.split("@");
  if (atParts.length > 2) {
    value = atParts[0] + "@" + atParts.slice(1).join("").replace(/@/g, "");
  }
    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(/\.@/, "@");
    value = value.replace(/@\.{1}/, "@");
    value = value.slice(0, 35);
    e.target.value = value;
    setValue("emailValid", value, { shouldValidate: true });
  };
  console.log(mailVerified, resumeVal?.email, "saveRelationEmailVal");

  useEffect(() => {
  if (resumeVal?.relation) {
    setCheckRelation(resumeVal?.relation);
  }
}, [resumeVal?.relation]);
  

  return (
    <div className="individual-acc-card">
      <form onSubmit={handleSubmit(onFinalSubmit)}>
        <div className="card-box">
          {saveRelationEmailVal !== null || mailAlreadyRegis === "NO" ? (
            <div className="mobile-verify-sec">
              <label className="mob-card-header">Email Verification</label>
              <span className="verify-text">
                Verified
                <img className="verified-success" src={rightTick} />
              </span>
            </div>
          ) : (
            <>
              <label className="mob-card-header">Email Verification</label>
              <div className="input-header hni-input-header">
                <label className="input-title">
                  Email Address<span style={{ color: "red" }}>*</span>
                </label>
                {console.log(props.mobileVerify, mailVerified, resumeVal?.email, "mailVerify")
                }
                <div className="text-input">
                  <input
                    type="text"
                    placeholder="Enter email address"
                    className="input-st email-input"
                    autoComplete="off"
                    maxLength={35}
                    {...register("emailValid")}
                    defaultValue={mailVerified || resumeVal?.email}
                    onKeyPress={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) =>handleEmailInput(e)}
                    ref={(e) => {
                      register("emailValid").ref(e);
                      inputRef.current = e;
                    }}
                    onPaste={handlePaste}
                    disabled={
                      props.mobileVerify === false || mailVerified || resumeVal?.email
                    }
                  />
                  
                    {(mailVerified?.length > 0 || resumeVal?.email) && (
                      <span className="verify-text">
                        Verified
                        <img className="verified-success" src={rightTick} />
                      </span>
                    )}
                  {errors?.emailValid && (
                    <p className="forget-link add-error">
                      <span>{errors?.emailValid?.message}</span>
                    </p>
                  )}
                </div>
              </div>

              {mailAlreadyRegis === "YES" && mailVerified?.length > 0 && (
                <div className="input-header hni-input-header">
                  <label className="input-title">
                    Select Relationship<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="text-input">
                    <select
                      className="report-custom-select brokerage-select input-st"
                      onChange={(e) => setCheckRelation(e?.target?.value)}
                      value={checkRelation}
                      disabled={!!resumeVal?.relation}
                    >
                      <option value="">Select</option>
                      {relation &&
                        relation.map((item) => (
                          <option value={item?.name}>{item?.name}</option>
                        ))}
                    </select>
                  </div>
                </div>
              )}
              {console.log(effectiveEmail, initialEmail, errors?.emailValid, "emailValid")
              }

              {mailAlreadyRegis !== "YES" ? (
                <div className="wrap-button">
                  <button
                    type="submit"
                    className={`${
                      (effectiveEmail && effectiveEmail !== initialEmail && !errors?.emailValid) 
                        ? "val-btn-wrap"
                        : "disable-btn val-btn-wrap"
                    }`}
                    disabled={!effectiveEmail || effectiveEmail === initialEmail || errors?.emailValid}
                  >
                    {otpLoader ? <SmallLoader /> : <>Validate</>}
                  </button>
                </div>
              ) : (
                <div
                className="wrap-button"
                >
                  <button
                    type="submit"
                    className={`${
                      mailVerified?.length === 0 || checkRelation === ""
                        ? "disable-btn val-btn-wrap"
                        : "val-btn-wrap"
                    }`}
                    disabled={mailVerified?.length === 0 || checkRelation === ""}
                  >
                    {saveLoader ? <SmallLoader /> : <>Save</>}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </form>

      <Modal
        show={otpModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <h2 className="h2-css-all">Enter OTP</h2>
            <div className="wrap-otp-text">
              <p className="otp-text">
                A one-time password has been sent to your mail id{" "}
                {getValues("emailValid")?.length > 0 && maskEmail(getValues("emailValid"))}
                <button
                  className="chang-btn"
                  onClick={() => {setOtpModal(false);
                    setTimeout(() => {
                      inputRef.current?.focus(); 
                    }, 300);
                  }}
                >
                  Change
                </button>
              </p>
            </div>
            <OtpInput
              otpValues={otpValues}
              setOtpValues={setOtpValues}
              onVerify={handleVerifyData}
              otpBtn={otpBtn}
              seconds={seconds}
              minutes={minutes}
              onOtpComplete={handleOtpComplete}
            />

            <div className="nominee-btn-wrapper">
              <div className="wrap-button">
                <button
                  type="submit"
                  className="default-btn-wrap"
                  onClick={() => setOtpModal(false)}
                >
                  Cancel
                </button>
              </div>
              <div
                className="wrap-button"
              >
                <button
                  type="submit"
                  className={`${
                    !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                  }`}
                  onClick={() => handleVerifyData()}
                  disabled={!isOtpComplete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default IndividualEmailCard;
